import { styled } from 'styled-components';
import { ReactComponent as SearchSvg } from '../../assets/icons/search.svg';

export const SearchIcon = styled(SearchSvg)`
  width: 20px;
  height: auto;
  path {
    stroke-width: 1.75;
  }
`;

// export const Search = styled.input`
//   width: 260px;
//   border-radius: 10px;
//   display: flex;
//   border: none;
//   padding: 8px 12px 8px 46px;
//   align-items: center;
//   gap: 10px;
//   border-bottom: 1px solid #f6e7ea;
//   background: #f5edef;
//   color: #000;

//   font-size: 16px;
//   font-style: normal;
//   font-family: 'Poppins-Medium';

//   line-height: normal;
//   letter-spacing: -0.2px;
//   &:focus {
//     outline: none;
//   }
// `;

export const Search = styled.input`
  border-radius: 10px;
  font-family: 'Poppins-Medium';

  width: ${props => (props.$open ? '260px' : '45px')};

  user-select: none;
  height: 45px;

  background: #fff;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.05);
  border: none;
  padding-left: 42px;
  transition: all 0.2s ease-in-out;
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
  &::placeholder {
    opacity: ${props => (props.$open ? 0.75 : 0)};
    font-family: 'Poppins-Medium';

    font-size: 12px;

    letter-spacing: 0.067px;
  }
`;

export const StyledInput = styled.div`
  position: relative;
  border-radius: 10px;
  cursor: pointer;
`;

export const IconContainer = styled.div`
  position: absolute;
  top: 55%;
  left: 12px;
  transform: translateY(-50%);
`;

export const HeaderContainer = styled.div`
  margin-top: 33px;
  margin-bottom: 33px;
  min-height: 40px;
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;
`;

export const StyledHeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
`;
export const Title = styled.span`
  color: #000;
  user-select: none;
  font-family: Playfair Display;
  font-size: 32px;
  font-style: normal;
  font-weight: 700;
  line-height: 37px;
`;
export const Subtitle = styled.span`
  font-family: 'Poppins-Medium';
  font-size: 16px;

  letter-spacing: -0.408px;
`;

export const SearchContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
`;

export const Button = styled.button`
  display: inline-flex;
  padding: 8px 16px 8px 12px;
  justify-content: center;
  outline: none;
  align-items: center;
  border-radius: 16px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 1.04%, rgba(0, 0, 0, 0.5) 100%), #262626;
  box-shadow: 0px 8px 12px 0px rgba(0, 0, 0, 0.1);
  gap: 10px;
  user-select: none;
  border: none;
  cursor: pointer;
  color: #fffdfc;
  text-align: center;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px;
  letter-spacing: -0.408px;
  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
`;

export const ButtonTransparent = styled.button`
  display: inline-flex;
  // padding: 8px 16px 8px 12px;
  justify-content: center;
  align-items: center;
  // border-radius: 16px;
  outline: none;
  gap: 10px;
  user-select: none;
  border: none;
  cursor: pointer;
  color: #fffdfc;
  text-align: center;
  color: #000;

  font-size: 16px;
  font-style: normal;
  font-family: 'Poppins-Medium';

  line-height: 22px;
  letter-spacing: -0.408px;
  &:active {
    transition: all 0.2s ease-in-out;
    scale: 0.95;
  }
  background-color: transparent;
`;
export const HeaderRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 30px;
`;
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  flex-wrap: wrap;
`;
